import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class CanvasSettings extends VisualizatorSettings {
  constructor(settings, customSettingsCoyFunc = ObjectCreator.deepCopy) {
    super();
    this.customSettingsCoyFunc = customSettingsCoyFunc;
    const copiedFileds = ["x", "y", "width", "height"];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "_parentHtmlObject") {
        this[key] = settings[key];
      } else if (copiedFileds.includes(key)) {
        this[key] = settings[key].copy();
      } else if (key == "items") {
        this.items = VisualizatorSettings.copySettingsArray(settings.items);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = customSettingsCoyFunc(settings[key]);
        }
      }
    }
  }

  copy() {
    return new CanvasSettings(this, this.customSettingsCoyFunc);
  }
}
